
import { useTranslatedContent } from '../../../hooks/useTranslatedContent';
import {  Category } from '../../../types/categories';
import { useTranslation } from 'react-i18next';
import { useFilters } from '../../../hooks/useFilters';
import { useCategories } from '../../../hooks/useCategories';
import { useDataStore } from '../../../stores/pageTitleStore';
import { useNavigate } from 'react-router-dom';

import styles from './PathInfo.module.less';

interface PathInfoProps {
  category: Category | undefined;
  pageSlug: string | undefined;
}



const PathInfo: React.FC<PathInfoProps> = ({ pageSlug }) => {
  const { getTranslation } = useTranslatedContent();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { selectedCategory, setSelectedCategory, setSelectedSubcategories } =
    useFilters();
 

  const courseDetails = useDataStore((state: any) => state.data);

  const { data: categoriesData } = useCategories();

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const categorySlug = pathSegments[0];
  const category = categoriesData?.categories.find(
    (cat) => cat.slug === categorySlug
  );

  const categoryAboutCategoryPage = categoriesData?.categories.find(
    (cat) => cat.id === selectedCategory
  );




  const getCategoryName = () => {
    if (category) {
      return getTranslation(category, 'category_name');
    }
    return '';
  };

  const handleCategoryClickAbout = (
    categoryId: string,
    categorySlug: string
  ) => {

   
    setSelectedCategory(categoryId);
    navigate(`/${categorySlug}`);

    setSelectedSubcategories([]);

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getPageTitle = () => {
    if (!courseDetails) return;
    if (courseDetails?.data) {
      const fullTitle = getTranslation(courseDetails.data, 'title');
      if (fullTitle !== 'Translation not available') {

        return fullTitle;
      }
    }
    return '';
  };



  if (pageSlug === 'about-fund') {
    return <div className={styles.selectedCategory}>{t('About MethodFund')}</div>;
  }



  if (pageSlug === 'about_project') {
    return (
      <div className={styles.pathInfo}>
        {categoryAboutCategoryPage && (
          <div
            className={`${styles.selectedCategory} ${styles.selectedCategory__click}`}
            onClick={() =>
              handleCategoryClickAbout(
                categoryAboutCategoryPage.id,
                categoryAboutCategoryPage.slug
              )
            }
          >
            {getTranslation(categoryAboutCategoryPage, 'category_name')}
            <span className={styles.decor}>/</span>{' '}
          </div>
        )}
        <div className={styles.selectedCategory}> {t('About the direction')}</div>
      </div>
    );
  }
  return (
    <div className={styles.pathInfo}>
      {category && (
        <div
          className={styles.selectedCategory}
          onClick={() => handleCategoryClickAbout(category.id, category.slug)}
        >
          {getCategoryName()}
          <span className={styles.decor}>/</span>{' '}
        </div>
      )}
      {pageSlug && (
        <>
          <h3 className={styles.pageTitle}>{getPageTitle()}</h3>{' '}
        </>
      )}
    </div>
  );
};

export default PathInfo;
